import React from 'react';
import classNames from 'classnames';
import { Button, Icon } from '@fiverr-private/fit';
import { l_translation } from '@fiverr-private/fit/icons';
import { I18n } from '@fiverr-private/fiverr_context';
import { translationButtonProps } from '../../../utils/props';

import './style.scss';

const TranslationButton = ({
    toggled = false,
    loading = false,
    withDisclaimer,
    className,
    onClick = Function.prototype,
    children,
    showGoogleMTExperience = true
}) => (
    <div className={classNames('default-translation-button', className)}>
        <Button className="translation-button"
            color={Button.COLORS.BLUE} fill={Button.FILLS.GHOST}
            onClick={onClick}>
            <div className="icons-container">
                {loading ?
                    <i className="loading-icon"/> :
                    <Icon className="translation-icon" size={22}>{l_translation}</Icon>
                }
            </div>
            {children &&
                <p className="text-body-2">
                    {children}
                </p>
            }
        </Button>
        {toggled && withDisclaimer && <p className={classNames('text-body-3', 'translation-disclaimer')}>
            <I18n k={'machine_translation.disclaimer'}/>
            {showGoogleMTExperience && <i className="vendor-disclaimer"/>}
        </p>
        }
    </div>
);

TranslationButton.propTypes = translationButtonProps;

export default TranslationButton;
